// extracted by mini-css-extract-plugin
export var chevron = "_a6-0";
export var dropdownIcon = "_a6-1";
export var dropdownIconOpen = "_a6-2";
export var externalLinkIcon = "_a6-6";
export var multipleOrdersDropdownItem = "_a6-4";
export var multipleOrdersLink = "_a6-5";
export var multipleOrdersTitle = "_a6-3";
export var orderLink = "_a6-7";